
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinar/[slug]/[id]",
      function () {
        return require("private-next-pages/webinar/[slug]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinar/[slug]/[id]"])
      });
    }
  